"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rdnsDimensions = void 0;
const rdnsDimensions = exports.rdnsDimensions = {
  rdns_src_hostname: {
    Label: 'rDNS Hostname',
    Direction: 'src',
    Category: 'rDNS'
  },
  rdns_dst_hostname: {
    Label: 'rDNS Hostname',
    Direction: 'dst',
    Category: 'rDNS'
  }
};